export default {
  "content": "<path d=\"M15.025 1.318c.234-1.04 1.716-1.04 1.95 0l1.49 6.596a1 1 0 001.51.625l5.717-3.61c.901-.57 1.948.478 1.38 1.38l-3.611 5.716a1 1 0 00.625 1.51l6.596 1.49c1.04.234 1.04 1.716 0 1.95l-6.596 1.49a1 1 0 00-.625 1.51l3.61 5.717c.57.901-.478 1.948-1.38 1.38l-5.716-3.611a1 1 0 00-1.51.625l-1.49 6.596c-.234 1.04-1.716 1.04-1.95 0l-1.49-6.596a1 1 0 00-1.51-.625l-5.717 3.61c-.901.57-1.948-.478-1.38-1.38l3.611-5.716a1 1 0 00-.625-1.51l-6.596-1.49c-1.04-.234-1.04-1.716 0-1.95l6.596-1.49a1 1 0 00.625-1.51l-3.61-5.717c-.57-.901.478-1.948 1.38-1.38l5.716 3.611a1 1 0 001.51-.625l1.49-6.596z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};